/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlShift = "/master/shifts";
const urlShiftDeleteMultiple = "/master/shifts/delete-multiple";

const state = {
  shifts: [],
  pagination: {
    current_page: 1,
    per_page: 60,
    total: 0,
  },
};

const actions = {
  /**
   * Get list shifts
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListShifts({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlShift}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_SHIFTS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create shift
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlShift, payload);
  },

  /**
   * Update shift
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlShift}/${id}`, payload);
  },

  /**
   * Delete shift
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlShift}/${id}`);
  },

  /**
   * delete multiple shift
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlShiftDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_SHIFTS(state, data) {
    state.shifts = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
